if (!customElements.get("carousel-component")) {
  class Carousel extends HTMLElement {
    constructor() {
      super();
      this.carouselElement = this;

      this.desktopPerPage = this.carouselElement.dataset['desktopperpage'] || 4;
      this.mobilePerPage = this.carouselElement.dataset['mobileperpage'] || 1;
      this.focus = this.carouselElement.dataset['focus'];
      this.mobileFocus = this.carouselElement.dataset['mobilefocus'] || this.focus;
      this.type = this.carouselElement.dataset['type'];
      this.gap = this.carouselElement.dataset['gapbetweenslides'] || 0;
      this.gapMobile = this.carouselElement.dataset['gapbetweenslidesonmobile'] || 0;
      this.autoplaySpeed = parseInt(this.dataset['autoplaySpeed']) || 3000;
      this.direction = this.carouselElement.dataset['direction'] || 'ltr';
      this.perMove = this.carouselElement.dataset['permove'] || 1;
      this.mobilePaddingLeft = this.carouselElement.dataset['mobilepaddingleft'] || '0';
      this.mobilePaddingRight = this.carouselElement.dataset['mobilepaddingright'] || '0';
      this.desktopPaddingLeft = this.carouselElement.dataset['desktoppaddingleft'] || '0';
      this.desktopPaddingRight = this.carouselElement.dataset['desktoppaddingright'] || '0';

      // Data attribute string matching for correct boolean value
      // The fallback is used if the developer make mistake the code is forgiving
      // Read more here https://stackoverflow.com/questions/263965/how-can-i-convert-a-string-to-boolean-in-javascript
      this.showarrows = this.carouselElement.dataset['showarrows'] === 'true' || false;
      this.autoplay = this.carouselElement.dataset['autoplay'] === 'true' || false;
      this.showarrowsonmobile = this.carouselElement.dataset['showarrowsonmobile'] === 'true' || false;
      this.showdots = this.carouselElement.dataset['showdots'] === 'true' || false;
      this.showdotsonmobile = this.carouselElement.dataset['showdotsonmobile'] === 'true' || false;
      this.isNavigation = this.carouselElement.dataset['isnavigation'] === 'true' || false;
      this.disableDrag = this.carouselElement.dataset['disabledrag'] === 'true' || false;
      this.destroyOnMobile = this.carouselElement.dataset['enableonmobile'] == 'false' || false;
      this.destroyOnDesktop = this.carouselElement.dataset['enableondesktop'] == 'false' || false;
      this.omitEnd = this.carouselElement.dataset['omitend'] == 'true' || false;

      this.refresh = this.carouselElement.dataset['refresh'] == 'true' || false;
      this.sync = this.carouselElement.dataset['carouselsyncselector'] || false;

      // Carousel element should have class splide
      if (!this.carouselElement.classList.contains('splide')) return;
      this.initCarousel();
    }

    initCarousel() {
      if (this.destroyOnMobile && this.destroyOnDesktop) return;

      // More option available here https://splidejs.com/documents/
      // This slider can be customized as require check the above doc before adding any new 
      // Slider library.
      this.carousel = new Splide(this.carouselElement, {
        perPage: this.desktopPerPage,
        ...(this.type ? { type: this.type } : {}),
        ...(this.focus ? { focus: this.focus } : {}),
        autoplay: this.autoplay,
        interval: this.autoplaySpeed,
        speed: 600,
        pauseOnHover: true,
        pauseOnFocus: true,
        gap: this.gap,
        arrows: this.showarrows,
        pagination: this.showdots,
        isNavigation: this.isNavigation,
        drag: !this.disableDrag,
        direction: this.direction,
        destroy: this.destroyOnDesktop,
        padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
        omitEnd: this.omitEnd,
        perMove: this.perMove,
        breakpoints: {
          750: {
            focus: this.mobileFocus,
            padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
            perPage: this.mobilePerPage,
            arrows: this.showarrowsonmobile,
            pagination: this.showdotsonmobile,
            gap: this.gapMobile,
            destroy: this.destroyOnMobile,
          }
        },
      });

      if (this.sync) {
        this.initCarouselSync()
      } else {
        this.carousel.mount();

        if (this.refresh)
          this.carousel.refresh()
      }
    }

    initCarouselSync() {
      this.syncElement = document.querySelector(this.sync);
      this.direction = this.syncElement.dataset['direction'] || 'ltr'

      this.carouselSync = new Splide(this.sync, {
        updateOnMove: true,
        perPage: this.syncElement.dataset['desktopperpage'] || 4,
        type: this.syncElement.dataset['type'] || 'loop',
        focus: this.syncElement.dataset['focus'] || 'center',
        isNavigation: this.syncElement.dataset['isnavigation'] === 'true' || false,
        pagination: false,
        gap: this.gap,
        arrows: this.syncElement.dataset['showarrows'] === 'true' || false,
        drag: true,
        // Conditional configuration for 'ttb' direction
        ...(this.direction === 'ttb' && {
          height: this.getPrimarySlideFirstImageHeight(),
          direction: 'ttb',
          autoHeight: true,
        }),
        breakpoints: {
          767: {
            height: 'auto',
            direction: 'ltr',
            gap: this.gapMobile,
            arrows: this.showarrowsonmobile
          }
        },
      });


      this.carousel.sync(this.carouselSync);
      this.carousel.mount();
      this.carouselSync.mount();
    };

    refreshSlider() {
      this.carousel.refresh();
      if (this.carouselSync) {
        this.carouselSync.refresh();
      }
    }

    getPrimarySlideFirstImageHeight() {
      const image = this.querySelector('.splide__list img');
      const containerWidth = this.querySelector('.splide__list').clientWidth;

      // Get the original width and height of the image
      const originalWidth = image.getAttribute('width');
      const originalHeight = image.getAttribute('height');

      // Calculate the scaled height to fit within the container
      return (containerWidth / originalWidth) * originalHeight;
    }
  }

  // Exposing the Carousel class globally to allow other custom elements, like the product-form, to extend its functionality.
  window.Carousel = Carousel;
  customElements.define('carousel-component', Carousel);
}

if (!customElements.get("videos-carousel-component")) {
  class VideosCarousel extends HTMLElement {
    constructor() {
      super();
      this.carouselElement = this;

      this.desktopPerPage = this.carouselElement.dataset['desktopperpage'] || 4;
      this.mobilePerPage = this.carouselElement.dataset['mobileperpage'] || 1;
      this.focus = this.carouselElement.dataset['focus'];
      this.type = this.carouselElement.dataset['type'];
      this.gap = this.carouselElement.dataset['gapbetweenslides'] || 0;
      this.gapMobile = this.carouselElement.dataset['gapbetweenslidesonmobile'] || 0;
      this.autoplaySpeed = this.dataset['autoplaySpeed'] || 3000;
      this.direction = this.carouselElement.dataset['direction'] || 'ltr';
      this.perMove = this.carouselElement.dataset['permove'] || 1;
      this.mobilePaddingLeft = this.carouselElement.dataset['mobilepaddingleft'] || '0';
      this.mobilePaddingRight = this.carouselElement.dataset['mobilepaddingright'] || '0';
      this.desktopPaddingLeft = this.carouselElement.dataset['desktoppaddingleft'] || '0';
      this.desktopPaddingRight = this.carouselElement.dataset['desktoppaddingright'] || '0';

      // Data attribute string matching for correct boolean value
      this.showarrows = this.carouselElement.dataset['showarrows'] === 'true' || false;
      this.autoplay = this.carouselElement.dataset['autoplay'] === 'true' || false;
      this.showarrowsonmobile = this.carouselElement.dataset['showarrowsonmobile'] === 'true' || false;
      this.showdots = this.carouselElement.dataset['showdots'] === 'true' || false;
      this.showdotsonmobile = this.carouselElement.dataset['showdotsonmobile'] === 'true' || false;
      this.isNavigation = this.carouselElement.dataset['isnavigation'] === 'true' || false;
      this.disableDrag = this.carouselElement.dataset['disabledrag'] === 'true' || false;
      this.destroyOnMobile = this.carouselElement.dataset['enableonmobile'] == 'false' || false;
      this.destroyOnDesktop = this.carouselElement.dataset['enableondesktop'] == 'false' || false;
      this.omitEnd = this.carouselElement.dataset['omitEnd'] == 'false' || false;

      this.refresh = this.carouselElement.dataset['refresh'] == 'true' || false;
      this.sync = this.carouselElement.dataset['carouselsyncselector'] || false;
    }

    connectedCallback() {
      if (!this.carouselElement.classList.contains('splide')) return;
      this.initCarousel();
      this._setupEventListeners();
      this._mountCarousel();
      this.setVideosObserver();
    }

    disconnectedCallback() {
      this._removeEventListeners();
      if (this.carousel) {
        this.carousel.destroy();
      }
    }

    setVideosObserver() {
      const videos = this.querySelectorAll('video-media');
      if (!videos.length) return;

      const options = {
        root: null, 
        rootMargin: '0px',
        threshold: 0.5 
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const videoElement = entry.target;

          const nativeVideo = videoElement.querySelector('video');
          if (nativeVideo) {
            if (entry.isIntersecting) {
              nativeVideo.play().catch(error => {
                console.warn('Auto-play was prevented:', error);
              });
            } else {
              nativeVideo.pause();
            }
            return;
          }

          const iframe = videoElement.querySelector('iframe');
          if (iframe) {
            if (entry.isIntersecting) {
              if (iframe.src.includes('youtube')) {
                iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
              } else if (iframe.src.includes('vimeo')) {
                iframe.contentWindow.postMessage('{"method":"play"}', '*');
              }
            } else {
              if (iframe.src.includes('youtube')) {
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
              } else if (iframe.src.includes('vimeo')) {
                iframe.contentWindow.postMessage('{"method":"pause"}', '*');
              }
            }
          }
        });
      }, options);

      videos.forEach(video => {
        observer.observe(video);
      });

      this._videoObserver = observer;

      const originalDisconnected = this.disconnectedCallback;
      this.disconnectedCallback = function () {
        if (this._videoObserver) {
          this._videoObserver.disconnect();
        }
        if (originalDisconnected) {
          originalDisconnected.call(this);
        }
      };
    }

    initCarousel() {
      if (this.destroyOnMobile && this.destroyOnDesktop) return;

      this.carousel = new Splide(this.carouselElement, {
        perPage: this.desktopPerPage,
        ...(this.type ? { type: this.type } : {}),
        ...(this.focus ? { focus: this.focus } : {}),
        autoplay: this.autoplay,
        interval: parseInt(this.autoplaySpeed),
        gap: this.gap,
        arrows: this.showarrows,
        pagination: this.showdots,
        isNavigation: this.isNavigation,
        drag: !this.disableDrag,
        direction: this.direction,
        destroy: this.destroyOnDesktop,
        padding: { left: this.desktopPaddingLeft, right: this.desktopPaddingRight },
        omitEnd: this.omitEnd,
        perMove: this.perMove,
        rewind: true,
        pauseOnHover: false,
        resetProgress: true,
        breakpoints: {
          750: {
            padding: { left: this.mobilePaddingLeft, right: this.mobilePaddingRight },
            perPage: this.mobilePerPage,
            arrows: this.showarrowsonmobile,
            pagination: this.showdotsonmobile,
            gap: this.gapMobile,
            destroy: this.destroyOnMobile,
          }
        },
      });
    }

    _setupEventListeners() {
      if (!this.carousel) return;

      this._onVideoLoadedBound = this._onVideoLoaded.bind(this);
      this.addEventListener('slideshow:video-loaded', this._onVideoLoadedBound);

      this._onViewportResizeBound = () => {
        if (this.carousel) {
          this._handleSlideTransition(this.carousel.index);
        }
      };
      this._viewportQuery = window.matchMedia('(min-width: 768px)');
      this._viewportQuery.addEventListener('change', this._onViewportResizeBound);

      this.carousel.on('ready', () => {
        this._emitCustomEvent('carousel:ready', {});
        const activeSlide = this.carouselElement.querySelector('.splide__slide.is-active') || this.carousel.Components?.Elements?.slides[0];
        this._setMobileArrowsHeight(activeSlide);
        this._updateSlideTitles();
        this._handleSlideTransition(0);
      });

      this.carousel.on('move', (newIndex, oldIndex, destIndex) => {
        if (oldIndex !== undefined && oldIndex !== -1 && oldIndex !== newIndex) {
          this._emitCustomEvent('carousel:move', {
            newIndex,
            oldIndex,
            destIndex
          });
        }
        const activeSlide = this.carousel.Components?.Elements?.slides[newIndex];
        this._setMobileArrowsHeight(activeSlide);
        this._updateSlideTitles();
      });

      this.carousel.on('moved', (newIndex, oldIndex, destIndex) => {
        this._emitCustomEvent('carousel:moved', {
          newIndex,
          oldIndex,
          destIndex
        });

        this._handleSlideTransition(newIndex);
      });

      this.carousel.on('refresh', () => {
        const idx = this.carousel.index || 0;
        const activeSlide = this.carouselElement.querySelector('.splide__slide.is-active') || this.carousel.Components?.Elements?.slides[idx];
        this._setMobileArrowsHeight(activeSlide);
        this._updateSlideTitles();
        this._handleSlideTransition(idx);
      });
    }

    _onVideoLoaded(e) {
      if (!this.carousel) return;
      const activeSlide = this.carousel.Components?.Elements?.slides[this.carousel.index];
      if (activeSlide && activeSlide.contains(e.target)) {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const mediaContainerSelector = isMobile ? '.mobile-only' : '.desktop-only';
        const activeMediaContainer = activeSlide.querySelector(mediaContainerSelector);
        const nativeVideo = activeMediaContainer ? activeMediaContainer.querySelector('video') : null;
        if (nativeVideo && this._activeVideoElement === nativeVideo) {
          return;
        }
        this._handleSlideTransition(this.carousel.index);
      }
    }

    _handleSlideTransition(newIndex) {
      if (!this.carousel) return;

      if (this._slideAdvanceTimer) {
        clearTimeout(this._slideAdvanceTimer);
        this._slideAdvanceTimer = null;
      }

      if (this._activeVideoEndedHandler && this._activeVideoElement) {
        this._activeVideoElement.removeEventListener('ended', this._activeVideoEndedHandler);
        this._activeVideoEndedHandler = null;
        this._activeVideoElement = null;
      }

      const slides = this.carousel.Components?.Elements?.slides || [];
      const activeSlide = slides[newIndex] || this.carouselElement.querySelector('.splide__slide.is-active');
      if (!activeSlide) return;

      // Pause videos on other slides and reset position
      slides.forEach((slide, idx) => {
        if (idx !== newIndex) {
          slide.querySelectorAll('video').forEach(v => {
            v.pause();
            v.currentTime = 0;
          });
          slide.querySelectorAll('video-media').forEach(vm => vm.pause?.());
        }
      });

      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      const mediaContainerSelector = isMobile ? '.mobile-only' : '.desktop-only';
      const activeMediaContainer = activeSlide.querySelector(mediaContainerSelector);
      const activeNativeVideo = activeMediaContainer
        ? activeMediaContainer.querySelector('video')
        : (!activeSlide.querySelector('.mobile-only') && !activeSlide.querySelector('.desktop-only') ? activeSlide.querySelector('video') : null);
      const activeVideoMedia = activeMediaContainer
        ? activeMediaContainer.querySelector('video-media')
        : (!activeSlide.querySelector('.mobile-only') && !activeSlide.querySelector('.desktop-only') ? activeSlide.querySelector('video-media') : null);
      const hasVideoLoader = activeMediaContainer ? activeMediaContainer.querySelector('slideshow-video-loader') : null;

      // Play the active video from start
      if (activeNativeVideo) {
        activeNativeVideo.currentTime = 0;
        activeNativeVideo.play().catch(() => {});
      } else if (activeVideoMedia) {
        activeVideoMedia.play?.();
      }

      // If carousel autoplay is disabled, do not auto-advance
      if (!this.autoplay) {
        if (activeNativeVideo) {
          activeNativeVideo.loop = true;
        }
        return;
      }

      const advanceByDuration = activeSlide.getAttribute('data-advance-by-video-duration') === 'true' || activeSlide.dataset.advanceByVideoDuration === 'true';
      const defaultDuration = parseInt(this.autoplaySpeed) || 6000;

      if (!advanceByDuration || (!activeNativeVideo && !activeVideoMedia && !hasVideoLoader)) {
        this._updateCountdowns(defaultDuration);
        if (this.carousel.Components?.Autoplay) {
          this.carousel.Components.Autoplay.play();
        }
        return;
      }

      // When controlling by video duration, pause Splide's fixed interval autoplay
      if (this.carousel.Components?.Autoplay) {
        this.carousel.Components.Autoplay.pause();
      }

      let durationMs = 0;

      if (activeNativeVideo && activeNativeVideo.duration > 0 && isFinite(activeNativeVideo.duration)) {
        durationMs = Math.round(activeNativeVideo.duration * 1000);
      } else {
        const datasetDuration = isMobile ? activeSlide.dataset.mobileDuration : activeSlide.dataset.desktopDuration;
        if (datasetDuration && parseInt(datasetDuration) > 0) {
          durationMs = parseInt(datasetDuration);
        }
      }

      // If video is not in DOM yet but video-loader is present, start countdown immediately with dataset duration
      if (!activeNativeVideo && !activeVideoMedia && hasVideoLoader) {
        this._updateCountdowns(durationMs || defaultDuration);
        return;
      }

      // If duration is not yet available, wait for metadata
      if (activeNativeVideo && (!durationMs || isNaN(durationMs))) {
        const onMeta = () => {
          if (activeNativeVideo.duration > 0 && isFinite(activeNativeVideo.duration)) {
            const dynamicDuration = Math.round(activeNativeVideo.duration * 1000);
            this._setupVideoEndAdvance(activeNativeVideo, dynamicDuration);
          }
        };
        activeNativeVideo.addEventListener('loadedmetadata', onMeta, { once: true });
        this._updateCountdowns(defaultDuration);
        return;
      }

      if (!durationMs) {
        durationMs = defaultDuration;
      }

      this._setupVideoEndAdvance(activeNativeVideo, durationMs);
    }

    _setupVideoEndAdvance(videoEl, durationMs) {
      if (this.currentSlideDuration !== durationMs) {
        this._updateCountdowns(durationMs);
      }

      if (this._slideAdvanceTimer) {
        clearTimeout(this._slideAdvanceTimer);
      }

      if (videoEl) {
        videoEl.loop = false; // ensure loop is false so ended fires
        const onEnded = () => {
          if (this._slideAdvanceTimer) clearTimeout(this._slideAdvanceTimer);
          this.carousel?.go('+1');
        };
        videoEl.addEventListener('ended', onEnded, { once: true });
        this._activeVideoEndedHandler = onEnded;
        this._activeVideoElement = videoEl;
      }

      // Fallback timer when duration completes
      this._slideAdvanceTimer = setTimeout(() => {
        this.carousel?.go('+1');
      }, durationMs + 250);
    }

    _updateCountdowns(durationMs) {
      if (!this.autoplay) return;
      this.currentSlideDuration = durationMs;
      const countdowns = this.querySelectorAll('carousel-countdown');
      countdowns.forEach(cd => {
        if (typeof cd.resetAnimation === 'function') {
          cd.resetAnimation(durationMs);
        }
      });
      this._emitCustomEvent('carousel:duration-change', { duration: durationMs });
    }

    _mountCarousel() {
      if (this.sync) {
        this.initCarouselSync()
      } else {
        this.carousel.mount();

        if (this.refresh) {
          setTimeout(() => {
            this.carousel.refresh();
          }, 0);
        }
      }
    }

    initCarouselSync() {
      this.syncElement = document.querySelector(this.sync);
      this.direction = this.syncElement.dataset['direction'] || 'ltr'

      this.carouselSync = new Splide(this.sync, {
        updateOnMove: true,
        perPage: this.syncElement.dataset['desktopperpage'] || 4,
        type: this.syncElement.dataset['type'] || 'loop',
        focus: this.syncElement.dataset['focus'] || 'center',
        isNavigation: this.syncElement.dataset['isnavigation'] === 'true' || false,
        pagination: false,
        gap: this.gap,
        arrows: this.syncElement.dataset['showarrows'] === 'true' || false,
        drag: true,
        ...(this.direction === 'ttb' && {
          height: this.getPrimarySlideFirstImageHeight(),
          direction: 'ttb',
          autoHeight: true,
        }),
        breakpoints: {
          767: {
            height: 'auto',
            direction: 'ltr',
            gap: this.gapMobile,
            arrows: this.showarrowsonmobile
          }
        },
      });

      this.carouselSync.on('ready', () => {
        this._emitCustomEvent('carousel:sync:ready', {});
      });

      this.carousel.sync(this.carouselSync);
      this.carousel.mount();
      this.carouselSync.mount();
    }

    _removeEventListeners() {
      if (this._slideAdvanceTimer) clearTimeout(this._slideAdvanceTimer);
      if (this._activeVideoEndedHandler && this._activeVideoElement) {
        this._activeVideoElement.removeEventListener('ended', this._activeVideoEndedHandler);
      }
      if (this._onVideoLoadedBound) {
        this.removeEventListener('slideshow:video-loaded', this._onVideoLoadedBound);
      }
      if (this._viewportQuery && this._onViewportResizeBound) {
        this._viewportQuery.removeEventListener('change', this._onViewportResizeBound);
      }
      if (!this.carousel) return;

      this.carousel.off('ready');
      this.carousel.off('move');
      this.carousel.off('moved');
    }

    _emitCustomEvent(eventName, detail) {
      const event = new CustomEvent(eventName, {
        bubbles: true,
        cancelable: true,
        detail
      });
      this.dispatchEvent(event);
    }

     _setMobileArrowsHeight(activeSlide) {
      if (!activeSlide) return;

      let mediaElement = activeSlide.querySelector('.mobile-slideshow-video video') ||
                         activeSlide.querySelector('.mobile-slideshow-video') ||
                         activeSlide.querySelector('.mobile-image');

      if (mediaElement) {
        const mediaHeight = mediaElement.offsetHeight;
        const arrowsContainer = this.querySelector('.splide__arrows');
        if (arrowsContainer && mediaHeight > 0) {
          arrowsContainer.style.setProperty('--arrows-mobile-height', `${mediaHeight}px`);
        }
      }
    }

    _updateSlideTitles() {
      if (!this.carousel) return;

      const total = this.carousel.length;
      const currentIndex = this.carousel.index;
      const prevIndex = (currentIndex - 1 + total) % total;
      const nextIndex = (currentIndex + 1) % total;

      const slides = this.carousel.Components.Elements.slides;
      const prevSlideTitle = slides[prevIndex]?.getAttribute('data-slide-title') || '';
      const nextSlideTitle = slides[nextIndex]?.getAttribute('data-slide-title') || '';

      const prevTitleElement = this.carouselElement.querySelector('[data-role="slide-title--prev"]');
      const nextTitleElement = this.carouselElement.querySelector('[data-role="slide-title--next"]');

      if (prevTitleElement) prevTitleElement.textContent = prevSlideTitle;
      if (nextTitleElement) nextTitleElement.textContent = nextSlideTitle;
    }

    refreshSlider() {
      this.carousel.refresh();
      if (this.carouselSync) {
        this.carouselSync.refresh();
      }
    }

    getPrimarySlideFirstImageHeight() {
      const image = this.querySelector('.splide__list img');
      const containerWidth = this.querySelector('.splide__list').clientWidth;

      const originalWidth = image.getAttribute('width');
      const originalHeight = image.getAttribute('height');

      return (containerWidth / originalWidth) * originalHeight;
    }

    next() {
      this.carousel?.go('+1');
    }

    prev() {
      this.carousel?.go('-1');
    }

    goTo(index) {
      this.carousel?.go(index);
    }

    refresh() {
      this.carousel?.refresh();
    }

    pause() {
      this.carousel?.Components.Autoplay?.pause();
    }

    play() {
      this.carousel?.Components.Autoplay?.play();
    }
  }

  window.VideosCarousel = VideosCarousel;
  customElements.define('videos-carousel-component', VideosCarousel);
}

if (!customElements.get('carousel-countdown')) {
  class CarouselCountdown extends HTMLElement {
    connectedCallback() {
      this.innerHTML = '<div class="countdown-overlay"></div>';

      const carousel = this.closest('videos-carousel-component');
      if (!carousel) {
        return;
      }

      carousel.addEventListener('carousel:move', () => {
        this.stopAnimation();
      });

      if (carousel.autoplay && carousel.currentSlideDuration > 0) {
        this.resetAnimation(carousel.currentSlideDuration);
      }
    }

    stopAnimation() {
      const overlay = this.querySelector('.countdown-overlay');
      if (overlay) {
        overlay.classList.remove('animate');
      }
    }

    resetAnimation(duration) {
      const overlay = this.querySelector('.countdown-overlay');
      if (!overlay) {
        return;
      }

      if (duration && duration > 0) {
        this.style.setProperty('--transition-time', `${duration}ms`);
      }

      overlay.classList.remove('animate');
      void overlay.offsetWidth;
      overlay.classList.add('animate');
    }
  }

  customElements.define('carousel-countdown', CarouselCountdown);
}